/* Live sync: re-reads the store's product feed before the page boots, so price, stock, condition tags, handles,
   new and removed products, and tagged photos always come from Shopify instead of the static snapshot.
   If the feed cannot be read in time (offline, password page, slow network) the static catalog.js is used as is.
   core.js waits on window.PGJ_LIVE_READY before it boots. */
(function () {
  var CAT = window.PGJ_CATALOG = window.PGJ_CATALOG || [];
  var Builder = window.PGJCatalogBuilder;
  var KEY = 'pgj.live.v2', TTL = 5 * 60 * 1000, TIMEOUT = 3500;
  if (!Builder || !window.fetch) return;

  // theme crops already resolved by the layout (absolute asset URLs), keyed by product id
  var prev = {};
  CAT.forEach(function (p) { prev[p.id] = p; });
  function isCrop(u) { return !!u && /\/\d+-[abc]\.webp/.test(u); }

  function read() {
    try { var c = JSON.parse(sessionStorage.getItem(KEY)); if (c && Date.now() - c.t < TTL && c.d && c.d.length) return c.d; } catch (e) { }
    return null;
  }
  function write(items) { try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: items })); } catch (e) { } }

  function fetchFeed() {
    var all = [];
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('feed ' + r.status); return r.json(); })
        .then(function (j) { var ps = j.products || []; all = all.concat(ps); return ps.length === 250 ? page(n + 1) : all; });
    }
    return page(1);
  }

  function finish(products) {
    if (!products.length) throw new Error('empty feed');
    var items = Builder.build(products, {});
    write(items);
    return items;
  }
  function apply(items) {
    if (!items || !items.length) return;
    CAT.length = 0;
    Array.prototype.push.apply(CAT, items);
  }

  var cached = read();
  var task = cached ? Promise.resolve(cached) : fetchFeed().then(finish);
  var timeout = new Promise(function (res) { setTimeout(res, TIMEOUT, null); });
  window.PGJ_LIVE_READY = Promise.race([task.then(apply), timeout]).catch(function () { });
})();
